import React from "react";
import * as styles from "./CustomPromoBanner.module.scss";
import { DiscountChip } from "@silversea-ssc/ui-components-react";
import { useCustomPromo } from "components/CustomPromo/hooks";

type Props = {
  isBannerVisible: boolean;
};

const CustomPromoBanner: React.FC<Props> = ({ isBannerVisible }) => {
  const { promoState } = useCustomPromo();

  if (!promoState.showCustomPromoBanner || !isBannerVisible) {
    return null;
  }

  return (
    <div className={styles.headerContainer}>
      <DiscountChip lineThrough={false} background="productTypeColor04">
        150 SHIPBOARD CREDIT OFFER - VALID UNTIL AUGUST 31
      </DiscountChip>
    </div>
  );
};

export default CustomPromoBanner;
